/**
 * @file contains functions used to create urls to reroute via <Link /> or navigate
 * Can be same with the path routes, but we keep urls to be future-proof
 */

import { ROUTE__HOME } from '../../constants/routing/routes';
import { Hotel } from '../../generated/graphql';
import { reportError } from '../../services/reporting';

import { getNoMatchUrl } from './404';

/**
 * Get URL for / route
 *
 * @param hotelId ID of the hotel
 * @returns       A string in a url format
 */
export const getHomeUrl = (hotelId: Hotel['id'] | null): string => {
  if (hotelId === null) {
    reportError('HotelId passed to getHomeUrl is null');
    return getNoMatchUrl();
  }
  return `/${hotelId}/${ROUTE__HOME}`;
};
